import Sites from "./components/Net-Zero-Components/Home/sites";
import Co2Emission from "./components/Net-Zero-Components/Home/co2-emission";
import AbbBuilding from "./components/Net-Zero-Components/Sites-KPIs/abb-building";
import SiteInformation from "./components/Net-Zero-Components/Sites-KPIs/site-information";
import CO2Saving from "./components/Net-Zero-Components/Sites-KPIs/co2-savings";
import ConsumptionByOccupancy from "./components/Net-Zero-Components/Sites-KPIs/consumption-by-occupancy";
import EnergyCost from "./components/Net-Zero-Components/Sites-KPIs/energy-cost";
import Weather from "./components/Net-Zero-Components/Sites-KPIs/weather";
import NzDropdownEnergyMix from "./components/Net-Zero-Components/Nz-Dropdown/nz-dropdown-energy-mix";
import NzDropdownCo2EmissionForecast from "./components/Net-Zero-Components/Nz-Dropdown/nz-dropdown-co2-emissions-forecast";
import Co2Emissions from "./components/Net-Zero-Components/Trends/co2-emissions";
import EnergyMix from "./components/Net-Zero-Components/Trends/energy-mix";
import Co2EmissionsForecast from "./components/Net-Zero-Components/Trends/co2-emissons-forecast";
import EnergyMixForecast from "./components/Net-Zero-Components/Trends/energy-mix-forecast";
import PowerFlow from "./components/Net-Zero-Components/Trends/power-flow";
import NzDropdownPowerFlow from "./components/Net-Zero-Components/Nz-Dropdown/nz-dropdown-power-flow";
import NzDropdownDeviceMeasures from "./components/Net-Zero-Components/Nz-Dropdown/nz-dropdown-device-measures";
import DeviceMeasures from "./components/Net-Zero-Components/Trends/device-measures";
import RenewableEnergy from "./components/Net-Zero-Components/Home/renewable-energy";
import ActualPower from "./components/Net-Zero-Components/Sites-KPIs/actual- power";
import CO2ETons from "./components/Net-Zero-Components/Sites-KPIs/co2e-tons";
import GreenEnergy from "./components/Net-Zero-Components/Sites-KPIs/green-energy";
import EVChargers from "./components/Net-Zero-Components/Sites-KPIs/ev-chargers";
import SankeyDemo from "./components/Net-Zero-Components/Sites-KPIs/demo";
import NzDropdownCo2Emission from "./components/Net-Zero-Components/Nz-Dropdown/nz-dropdown-co2-emissions";
import NzDropdownEnergyMixForecast from "./components/Net-Zero-Components/Nz-Dropdown/nz-dropdown-energy-mix-forecast";
import { getDefaultTimeStamp } from "./util";

export const DR_BASE_URL = process.env.REACT_APP_LAMBDA_ENV === "prod"
  ? `https://${process.env.REACT_APP_TD_BASE_URL}.execute-api.${process.env.REACT_APP_AWS_COGNITO_REGION}.amazonaws.com/prod/`
  : `https://${process.env.REACT_APP_TD_BASE_URL}.execute-api.${process.env.REACT_APP_AWS_COGNITO_REGION}.amazonaws.com/${process.env.REACT_APP_LAMBDA_ENV}/`;

export const BASE_URL = process.env.REACT_APP_LAMBDA_ENV === "prod" 
  ? `https://api.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/dashboard/`
  : `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/dashboard/`;

export const EA_BASE_URL = process.env.REACT_APP_LAMBDA_ENV === "prod" 
  ? `https://api.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/`
  : `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/`;

export const BASE_URL_CAES = `https://${process.env.REACT_APP_CAES_ML_BASE_URL}.execute-api.${process.env.REACT_APP_AWS_COGNITO_REGION}.amazonaws.com/${process.env.REACT_APP_CAES_LAMBDA_ENV}/`;
export const S3_BUCKET_DR_CAES = `s3://${process.env.REACT_APP_CAES_DR_S3_BUCKET_NAME}/`;

//Row 3
export const BASE_URL_DISTURBANCE_RECORDS = process.env.REACT_APP_LAMBDA_ENV === "prod"
  ? `https://${process.env.REACT_APP_DR_BASE_URL}.execute-api.${process.env.REACT_APP_AWS_COGNITO_REGION}.amazonaws.com/prod/`
  : `https://${process.env.REACT_APP_DR_BASE_URL}.execute-api.${process.env.REACT_APP_AWS_COGNITO_REGION}.amazonaws.com/${process.env.REACT_APP_LAMBDA_ENV}/`;

export const BASE_URL_DISTURBANCE_GENERATE_URL = process.env.REACT_APP_LAMBDA_ENV === "prod"
  ? `https://${process.env.REACT_APP_DR_BASE_URL}.execute-api.${process.env.REACT_APP_AWS_COGNITO_REGION}.amazonaws.com/prod/cognien-abb-dr/url/generate?`
  : `https://${process.env.REACT_APP_DR_BASE_URL}.execute-api.${process.env.REACT_APP_AWS_COGNITO_REGION}.amazonaws.com/${process.env.REACT_APP_LAMBDA_ENV}/cognien-abb-dr/url/generate?`;

export const BASE_URL_MFA = `https://${process.env.REACT_APP_AWS_COGNITO_MFA_URL}.auth.${process.env.REACT_APP_AWS_COGNITO_REGION}.amazoncognito.com/mfa?client_id=${process.env.REACT_APP_AWS_COGNITO_CLIENT_ID}&response_type=code&scope=email+openid+profile&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_AWS_COGNITO_MFA_ENV}.demo.cognien.abb%2F`;

//drdashboard
export const DRDASHBOARD_BASE_URL = process.env.REACT_APP_LAMBDA_ENV === "prod" 
  ? `https://api.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/drdashboard`
  : `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/drdashboard`;


//cybershield
const defaultTS = getDefaultTimeStamp();
const startTS = defaultTS.startDate;
const endTS = defaultTS.endDate;
const plantId = "Lab1";

export const CYBERSHIELD_BASE_API_URL = process.env.REACT_APP_LAMBDA_ENV === "prod" 
  ? `https://api.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/cybershielddashboard`
  : `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/cybershielddashboard`;


//EM Widgets Section


export const NZ_BASE_URL = `${BASE_URL}api`;

export const NZ_ERROR_LIST = {
  ERROR_FETCH_DATA: `There was a problem fetching the data`,
  ALARM_SUMMARY_EMPTY_DATA: `There are no alarms to display at this time.`,
  NO_EVENTS: `There are no events available at this time.`,
  NO_RECORDS: `There are no records available at this time.`,
  NO_DATA: `There is no data available at this time.`,
  NO_NOTIFICATIONS: `There are no new notifications at this time.`,
};

export const SITE_KPIS_CARD_JSON = [
  {
    widgetName: "ABB Building 1",
    widgetType: "small",
    renderComponent: () => <AbbBuilding />,
    enabled: true,
  },
  {
    widgetName: "Actual Power (kW)",
    widgetType: "small",
    renderComponent: () => <ActualPower />,
    enabled: true,
  },
  {
    widgetName: "ev Chargers (kW)",
    widgetType: "small",
    renderComponent: () => <EVChargers />,
    enabled: true,
  },
  {
    widgetName: "Site Information",
    widgetType: "small",
    renderComponent: () => <SiteInformation />,
    enabled: true,
  },
  {
    widgetName: "CO2e (tons)",
    widgetType: "small",
    renderComponent: () => <CO2ETons />,
    enabled: true,
  },
  {
    widgetName: "CO2e Savings (tons)",
    widgetType: "small",
    renderComponent: () => <CO2Saving />,
    enabled: true,
  },
  {
    widgetName: "Weather",
    widgetType: "small",
    renderComponent: () => <Weather />,
    enabled: true,
  },
  {
    widgetName: "Energy Cost(€)",
    widgetType: "small",
    renderComponent: () => <EnergyCost />,
    enabled: true,
  },
  {
    widgetName: "Consumption by Occupancy",
    widgetType: "small",
    renderComponent: () => <ConsumptionByOccupancy />,
    enabled: true,
  },
  {
    widgetName: "Green Energy",
    widgetType: "small",
    renderComponent: () => <GreenEnergy />,
    enabled: true,
  },
  {
    widgetName: "Energy Flow",
    widgetType: "medium",
    renderComponent: () => <SankeyDemo />,
    enabled: true,
  },
];

export const HOME_CARD_JSON = [
  {
    widgetName: "Sites",
    widgetType: "extra-large",
    renderComponent: () => <Sites />,
    enabled: true,
  },
  {
    widgetName: "CO2 Emissions",
    widgetType: "large",
    renderComponent: () => <Co2Emission />,
    enabled: true,
  },
  {
    widgetName: "Renewable Energy",
    widgetType: "large",
    renderComponent: () => <RenewableEnergy />,
    enabled: true,
  },
];

export const TRENDS_CARD_JSON = [
  {
    widgetName: "CO2 Emissions",
    widgetType: "trends",
    renderComponent: () => <Co2Emissions />,
    renderDropdown: () => <NzDropdownCo2Emission />,
    enabled: true,
  },
  {
    widgetName: "CO2 Emissions Forecast",
    widgetType: "trends",
    renderComponent: () => <Co2EmissionsForecast />,
    renderDropdown: () => <NzDropdownCo2EmissionForecast />,
    enabled: true,
  },
  {
    widgetName: "Energy Mix",
    widgetType: "trends",
    renderComponent: () => <EnergyMix />,
    renderDropdown: () => <NzDropdownEnergyMix />,
    enabled: true,
  },
  {
    widgetName: "Energy Mix Forecast",
    widgetType: "trends",
    renderComponent: () => <EnergyMixForecast />,
    renderDropdown: () => <NzDropdownEnergyMixForecast />,
    enabled: true,
  },
  {
    widgetName: "Power Flow",
    widgetType: "trends",
    renderComponent: () => <PowerFlow />,
    renderDropdown: () => <NzDropdownPowerFlow />,
    enabled: true,
  },
  {
    widgetName: "Device Measures",
    widgetType: "trends",
    renderComponent: () => <DeviceMeasures />,
    renderDropdown: () => <NzDropdownDeviceMeasures />,
    enabled: true,
  },
];
//EM Core Settings
export const EMCORE_TABS = ["Network", "Load Profiles", "Battery SoC", "Generation", "Grid"]
export const EMCORE_BASE_API_URL = "https://qcu8nocy83.execute-api.ap-south-1.amazonaws.com/prod/";
export const TEMP_EMCORE_BASE_PREDICTION_API_URL = "https://mvpfvetulf.execute-api.ap-south-1.amazonaws.com/prod/evaluate";

export const MICROGRID_MESSAGES = {
  NO_FILE_UPLOADED_NOTI: `Update input parameter setting for optimization results.`,
  NETWORK_FILES_UPLOAD_SUCCESS: `Network Parameters updated successfully`,
  NETWORK_FILES_UPLOAD_FAILURE: `There was a problem uploading the data`,
  OBJ_FUN_DATA_SUCCESS: `Objective Functions updated successfully`,
  OBJ_FUN_DATA_FAILURE: `There was a problem uploading the data`,
}

export const EMCORE_DASHBOARD_BASE_API_URL = localStorage.getItem("dashboard-charts-s3-url") ? localStorage.getItem("dashboard-charts-s3-url") : "https://emcore-data-bucket-test-demo.s3.amazonaws.com/output";
export const EMCORE_DASHBOARD_INPUT_API_URL = localStorage.getItem("dashboard-charts-s3-url-input") ? localStorage.getItem("dashboard-charts-s3-url-input") : "https://emcore-data-bucket-test-demo.s3.amazonaws.com/input";  

export const EMCORE_ERROR_LIST = {
  ERROR_FETCH_DATA: `There was a problem fetching the data`,
  ERROR_FILE_NOT_UPLOADED: `There is no data available`,
  ALARM_SUMMARY_EMPTY_DATA: `There are no alarms to display at this time.`,
  NO_EVENTS: `There are no events available at this time.`,
  NO_RECORDS: `There are no records available at this time.`,
  NO_DATA: `There is no data available at this time.`,

};

export const postRequestUrlPrefix = "https://api.dev.demo.cognien.abb/proofer/";

// WNT settings
export const WNT_BASE_API_URL = process.env.REACT_APP_LAMBDA_ENV === "prod" 
  ? `https://api.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/wnt`
  : `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/wnt`;

export const FILE_UPLOAD_API_URL = process.env.REACT_APP_LAMBDA_ENV === "prod" 
  ? `https://api.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/upload/files`
  : `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/upload/files`;

export const WNT_ERROR_LIST = {
  ERROR_FETCH_DATA: `There was a problem fetching the data`,
  NO_EVENTS: `There are no events available at this time.`,
  NO_RECORDS: `There are no records available at this time.`,
  NO_DATA: `There is no data available at this time.`,
  NO_NOTIFICATIONS: `There are no new notifications at this time.`,
};

export const SOLAR_ENERGY_BASE_API_URL = process.env.REACT_APP_LAMBDA_ENV === "prod" 
  ? `https://api.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/solarenergy`
  : `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/solarenergy`;


// Conditionally safe BASE URLs
export const BEDAS_BASE_URL_CAES = process.env.REACT_APP_LAMBDA_ENV === "prod" 
  ? `https://api.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/dashboard/`
  : `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/dashboard/`;

export const BEDAS_BASE_URL = process.env.REACT_APP_LAMBDA_ENV === "prod" 
  ? `https://api.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/dashboard/`
  : `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/dashboard/`;

export const BEDAS_BASE_URL_LOG = process.env.REACT_APP_LAMBDA_ENV === "prod" 
  ? `https://api.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/request/`
  : `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/request/`;

// S3 Bucket (no conditional logic required unless you want to add it too)
export const BEDAS_S3_BUCKET_DR_CAES = `s3://${process.env.REACT_APP_CAES_DR_S3_BUCKET_NAME}/`;

// MFA URL — sanitize `envPart` here too
// export const BASE_URL_MFA = `https://${process.env.REACT_APP_AWS_COGNITO_DOMAIN}.auth.${process.env.REACT_APP_AWS_REGION}.amazoncognito.com/mfa?client_id=${process.env.REACT_APP_AWS_COGNITO_CLIENT_ID}&response_type=code&scope=email+openid+profile&redirect_uri=https%3A%2F%2F${envPart}${process.env.REACT_APP_PROJECT_NAME}.cognien.abb%2F`;

export const OPERATION_AREA = "Bayrampaşa";
export const DEFAULT_SUBSTATION = "BAY-DS-8451";
export const DIALOG_MESSAGES = {
  ACK_DR_FILE: "Are you sure you want to acknowledge : ",
};
export const MAP_BOUNDRIES = {
  north: 42.1864,
  south: 39.8027,
  west: 27.5836,
  east: 29.4099,
}
export const mapCenter = {
  lat: 41.0082,
  lng: 28.9784
};

export const ERROR_LIST = {
  ERROR_FETCH_DATA: "There was a problem fetching the data",
  ALARM_SUMMARY_EMPTY_DATA: "There are no alarms to display at this time.",
  NO_EVENTS: "There are no events available at this time.",
  NO_RECORDS: "There are no records available at this time.",
  NO_DATA: "There is no data available at this time.",
  NO_NOTIFICATIONS: "There are no new notifications at this time.",
  NO_CRITICAL_ALERTS: "There are no critical alerts to display at this time.",
  WAIT: "Please wait while data loading...",
  MAP_NOT_LOADED: "Map cannot be loaded right now, sorry."
};


export const MESSAGES = {
  SIGN_IN_TRIGGER: "Verifying Credentials, Please Wait...",
  SIGN_IN_TIME_OUT_TRIGGER: "",
  POST_SIGN_WAITING: "Waiting for User Mail Verification",
  MFA_QR_CODE_PREFIX: `otpauth://totp/bedas-dev.auth.${process.env.REACT_APP_AWS_COGNITO_REGION}.amazoncognito.com:`,
  MFA_EMAIL_ABB_LOGO_URL: `https://qr-code-storage-test.s3.${process.env.REACT_APP_AWS_COGNITO_REGION}.amazonaws.com/Logo.png`,
  MFA_QR_CODE_SECRET_PREFIX: "?secret=",
  MFA_EMAIL_SENDER: "cognien.abb.noreply@gmail.com",
  MFA_EMAIL_SUBJECT: "Secure your CogniEn account with Two-Factor Authentication",
  MFA_EMAIL_TITLE: "Follow these steps to set up two-factor authentication:",
  MFA_INSTRUCTIONS_STEP_1: "1. Install an authenticator app on your mobile device",
  MFA_INSTRUCTIONS_STEP_2: "2. Scan this QR code with your authenticator app. ",
  MFA_INSTRUCTIONS_ALTERNATIVE_STEP: "Alternatively, you can manually enter a secret key in your authenticator app. ",
  MFA_INSTRUCTIONS_ALTERNATIVE_STEP_FOR_EMAIL: "If you want to manually enter a secret key in your authenticator app, the secret key is: ",
  FORGOT_PASSWORD_TITLE: "Password Change Successful",
  FORGOT_PASSWORD_BODY: "Your password has been changed successfully. Please login with your new password.",
  CONFIRM_USER_TITLE: "Confirm User Details",
  CONFIRM_USER_BODY: "Are you sure you want to save user details?",
  CONFIRMED_USER_TITLE: "Updated User Details",
  CONFIRMED_USER_BODY: "User Details updated successfully. The updates will be reflected in the next login",
  SUBSTATION_AREAS_LOAD_MESSAGE: "Please wait while we fetch the substations from the assigned operation areas",
  SUBSTATION_LOADING: "Loading substations...",
  POST_SIGN_UP_TRIGGER:
    "Thank you for creating an account with CogniEN.\n An email has been sent to your registered email. Please verify it to obtain approval from the administrators",
  IN_SIGNUP_TRIGGER: "Submitting Request..."
}


export const SUBSTATION_ROLES = [
  {
    "label": "Operational Manager",
    "value": "OperationalManager",
  },
  {
    "label": "Maintenance Engineer",
    "value": "MaintenanceEngineer",
  },
  {
    "label": "Technician",
    "value": "Technician",
  },

];

export const CHATBOT_REDIRECT_LINK = "https://mira-access.miraclesoft.com/"

export const ROUTE_PAGES = {
  SUBSTATION_EXPLORER: 'substation-explorer',
  SETTINGS: 'settings',
  HOME: 'Home'
};

export const ERROR_LISTOfAsset = {
  ERROR_FETCH_DATA: `There was a problem fetching the data`,
  ASSET_SUMMARY_EMPTY_DATA: `No data available for the selected device/substation.`,
  NO_EVENTS: `There are no events available at this time.`,
  NO_RECORDS: `There are no records available at this time.`,
  NO_DATA: `There is no data available at this time.`,
  NO_NOTIFICATIONS: `There are no new notifications at this time.`,
};

export const ERROR_LISTLogin = {
  ERROR_FETCH_DATA: "Failed to load user login data.",
  LOGIN_SUMMARY_EMPTY_DATA: "No data available for the selected device/substation.",
};


